export default "__VITE_ASSET__BiX_lIKW__"